//
import { ThemeOptions } from '@mui/material'
import RaList from './RaList'
import RaEdit from './RaEdit'
import RaShow from './RaShow'
import RaListToolbar from './RaListToolbar'
import RaRichTextInput from './RaRichTextInput'
import RaCreate from './RaCreate'
import RaBooleanField from './RaBooleanField'
// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: ThemeOptions): object {
  return Object.assign(
    RaList(theme),
    RaCreate(theme),
    RaEdit(theme),
    RaShow(theme),
    RaListToolbar(theme),
    RaRichTextInput(theme),
    RaBooleanField(theme),
  )
}
